import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ChangePasswordModalComponent } from './modal/change-password-modal.component';
import { ChangeEmailModalComponent } from './modal/change-email-modal.component';
import { AuthService } from 'app/core/auth/auth.service';

@Component({
    selector: 'security',
    templateUrl: './security.component.html',
    styleUrls: ['./security.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatSlideToggleModule,
        ReactiveFormsModule
    ]
})
export class SecurityComponent implements OnInit {
    userEmail: string = '';
    securityForm: FormGroup;

    constructor(
        private _matDialog: MatDialog,
        private _authService: AuthService,
        private _formBuilder: FormBuilder
    ) {}

    ngOnInit(): void {
        // Carregar o email do usuário do localStorage
        const userData = JSON.parse(this._authService.getLSUser);
        this.userEmail = userData?.email || '';

        // Inicializar formulário de configurações de segurança
        this.securityForm = this._formBuilder.group({
            twoFactorAuth: [{value: false, disabled: true}],
            newDeviceNotification: [{value: false, disabled: true}],
            logoutOnPasswordChange: [{value: false, disabled: true}],
            autoLogout: [{value: false, disabled: true}],
            requirePasswordForFinancial: [{value: false, disabled: true}]
        });
    }

    openChangeEmailModal(): void {
        const changeEmailDialogRef = this._matDialog.open(ChangeEmailModalComponent, {
            autoFocus: false,
            data: {},
            disableClose: false,
            width: '95%',
            maxWidth: '450px',
            height: 'auto',
            maxHeight: '95vh',
        });

        changeEmailDialogRef.afterClosed().subscribe(result => {
            if(result && result.action === 'saved') {
                // Deslogar o usuário (implementar depois)
                console.log('Email alterado com sucesso. Usuário será deslogado.');
            }
        });
    }

    openChangePasswordModal(): void {
        const changePasswordDialogRef = this._matDialog.open(ChangePasswordModalComponent, {
            autoFocus: false,
            data: {},
            disableClose: false,
            width: '95%',
            maxWidth: '450px',
            height: 'auto',
            maxHeight: '95vh',
        });

        changePasswordDialogRef.afterClosed().subscribe(result => {
            if(result && result.action === 'saved') {
                // Deslogar o usuário (implementar depois)
                console.log('Senha alterada com sucesso. Usuário será deslogado.');
            }
        });
    }
}
